module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newbutton"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 18px"
    }
  }, [_vm._v("\n        输入药名查询:\n        "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入药品名",
      "clearable": ""
    },
    model: {
      value: (_vm.medicineName),
      callback: function($$v) {
        _vm.medicineName = $$v
      },
      expression: "medicineName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-icon-search",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  })], 1), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "98%",
      "margin-left": "18px"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.tableHeaderColor
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "药品名称",
      "width": "400px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "manufacturer",
      "label": "产地"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "库存数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualNumber",
      "label": "实际数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-input', {
          staticStyle: {
            "width": "80px"
          },
          on: {
            "change": function($event) {
              return _vm.numberChange(row, $event)
            }
          },
          model: {
            value: (row.actualNumber),
            callback: function($$v) {
              _vm.$set(row, "actualNumber", $$v)
            },
            expression: "row.actualNumber"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "盘盈盘亏"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n                    " + _vm._s(row.diffNumber) + "\n                ")]
      }
    }])
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "current-page": _vm.currentPage,
      "page-size": this.Size,
      "layout": "total,prev, pager, next, jumper",
      "total": this.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 10px",
      "padding-bottom": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rvation()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "./checkStock"
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    }
  }, [_vm._v("取消")])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc00a180","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pharmacy/newbutton.vue
// module id = 1049
// module chunks = 2